import {
	CommBanner,
	type CommBannerProps,
} from 'fukku/CommsBanners/CommBanner/CommBanner'
import { cx } from 'utils/cx'

import styles from './PromoBannerContainer.module.scss'
import text from 'fukku/styles/texts.module.scss'

export function PromoBannerContainer(props: CommBannerProps) {
	return (
		<div className={cx(text.bodyXL, styles.promoBanner)}>
			<CommBanner {...props} />
		</div>
	)
}
